module.exports = __webpack_public_path__ + "static/img/3.002b85a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/eng/3.png
// module id = l5bW
// module chunks = 0